import { z } from 'zod';


// #/components/schemas/tradingBettable
export const TradingBettableZod = z.string();
export type TradingBettableType = z.TypeOf<typeof TradingBettableZod>;


// #/components/schemas/tradingStandard
export const TradingStandardZod = z.object({
    source: z.union([z.object({
        type: z.literal('MarketKeyFightEnd'),
    }), z.object({
        type: z.literal('MarketKeyFightWinner'),
    }), z.object({
        name: z.string().optional().nullable(),
        type: z.literal('MarketKeyFlavorless'),
    }), z.object({
        typeId: z.string(),
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        type: z.literal('MarketKeyInTimePeriod'),
    }), z.object({
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        line: z.number(),
        type: z.literal('MarketKeyRaceTo'),
    }), z.object({
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        pointNumber: z.number(),
        type: z.literal('MarketKeyScorer'),
    }), z.object({
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        no: z.number(),
        type: z.literal('MarketKeyTimeOf'),
    }), z.object({
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        team: z.string(),
        type: z.literal('MarketKeyToKeepACleanSheet'),
    }), z.object({
        typeId: z.string(),
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        type: z.literal('MarketThreeWayKey'),
    }), z.object({
        typeId: z.string(),
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        line: z.number(),
        type: z.literal('MarketThreeWayKeyWithLine'),
    }), z.object({
        typeId: z.string(),
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        type: z.literal('MarketTwoWayKey'),
    }), z.object({
        typeId: z.string(),
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        line: z.number(),
        type: z.literal('MarketTwoWayKeyWithLine'),
    }), z.object({
        typeId: z.string(),
        bettable: TradingBettableZod,
        timePeriod: z.union([z.object({
            type: z.literal('ExtraTime'),
        }), z.object({
            type: z.literal('FirstHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('FirstInnings'),
        }), z.object({
            type: z.literal('FullTime'),
        }), z.object({
            type: z.literal('SecondHalf'),
        }), z.object({
            no: z.number(),
            type: z.literal('SetTR'),
        })]),
        line: z.number(),
        team: z.string(),
        type: z.literal('MarketTwoWayKeyWithLineAndTeam'),
    })]),
});
export type TradingStandardType = z.TypeOf<typeof TradingStandardZod>;


// #/components/schemas/tradingBetLimits
export const TradingBetLimitsZod = z.object({
    maxBet: z.number(),
    maxWin: z.number(),
    maxMultipleBet: z.number(),
    liabilityLimit: z.number(),
});
export type TradingBetLimitsType = z.TypeOf<typeof TradingBetLimitsZod>;


// #/components/schemas/tradingMarketBetLimitsView
export const TradingMarketBetLimitsViewZod = z.object({
    matchingMarkets: z.union([z.object({
        matcher: z.union([z.object({
            typeId: z.string(),
            bettable: TradingBettableZod,
            timePeriod: z.union([z.object({
                type: z.literal('ExtraTime'),
            }), z.object({
                type: z.literal('FirstHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('FirstInnings'),
            }), z.object({
                type: z.literal('FullTime'),
            }), z.object({
                type: z.literal('SecondHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('SetTR'),
            })]),
            type: z.literal('ThreeWayKeyWithLine'),
        }), z.object({
            typeId: z.string(),
            bettable: TradingBettableZod,
            timePeriod: z.union([z.object({
                type: z.literal('ExtraTime'),
            }), z.object({
                type: z.literal('FirstHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('FirstInnings'),
            }), z.object({
                type: z.literal('FullTime'),
            }), z.object({
                type: z.literal('SecondHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('SetTR'),
            })]),
            type: z.literal('TwoWayKeyWithLine'),
        }), z.object({
            typeId: z.string(),
            bettable: TradingBettableZod,
            timePeriod: z.union([z.object({
                type: z.literal('ExtraTime'),
            }), z.object({
                type: z.literal('FirstHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('FirstInnings'),
            }), z.object({
                type: z.literal('FullTime'),
            }), z.object({
                type: z.literal('SecondHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('SetTR'),
            })]),
            team: z.string(),
            type: z.literal('TwoWayKeyWithLineAndTeam'),
        })]),
        type: z.literal('Multiple'),
    }), z.object({
        marketType: z.union([z.object({
            first: TradingStandardZod,
            second: TradingStandardZod,
            join: z.string(),
            no: z.number().optional().nullable(),
            type: z.literal('Double'),
        }), z.object({
            name: z.string(),
            type: z.literal('Manual'),
        }), z.object({
            name: z.string(),
            type: z.literal('RaceWinner'),
        }), z.object({
            source: z.union([z.object({
                type: z.literal('MarketKeyFightEnd'),
            }), z.object({
                type: z.literal('MarketKeyFightWinner'),
            }), z.object({
                name: z.string().optional().nullable(),
                type: z.literal('MarketKeyFlavorless'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                type: z.literal('MarketKeyInTimePeriod'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                type: z.literal('MarketKeyRaceTo'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                pointNumber: z.number(),
                type: z.literal('MarketKeyScorer'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                no: z.number(),
                type: z.literal('MarketKeyTimeOf'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                team: z.string(),
                type: z.literal('MarketKeyToKeepACleanSheet'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                type: z.literal('MarketThreeWayKey'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                type: z.literal('MarketThreeWayKeyWithLine'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                type: z.literal('MarketTwoWayKey'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                type: z.literal('MarketTwoWayKeyWithLine'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                team: z.string(),
                type: z.literal('MarketTwoWayKeyWithLineAndTeam'),
            })]),
            type: z.literal('Standard'),
        })]),
        type: z.literal('Single'),
    })]),
    betLimits: TradingBetLimitsZod,
});
export type TradingMarketBetLimitsViewType = z.TypeOf<typeof TradingMarketBetLimitsViewZod>;


// #/components/schemas/tradingBetLimitsGroupView
export const TradingBetLimitsGroupViewZod = z.object({
    name: z.string(),
    displayName: z.string(),
    marketBetLimits: z.array(TradingMarketBetLimitsViewZod).optional(),
    default: TradingBetLimitsZod,
});
export type TradingBetLimitsGroupViewType = z.TypeOf<typeof TradingBetLimitsGroupViewZod>;


// #/components/schemas/tradingMarketBetLimitsLegacyView
export const TradingMarketBetLimitsLegacyViewZod = z.object({
    matchingMarkets: z.union([z.object({
        matcher: z.union([z.object({
            typeId: z.string(),
            bettable: TradingBettableZod,
            timePeriod: z.union([z.object({
                type: z.literal('ExtraTime'),
            }), z.object({
                type: z.literal('FirstHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('FirstInnings'),
            }), z.object({
                type: z.literal('FullTime'),
            }), z.object({
                type: z.literal('SecondHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('SetTR'),
            })]),
            type: z.literal('ThreeWayKeyWithLine'),
        }), z.object({
            typeId: z.string(),
            bettable: TradingBettableZod,
            timePeriod: z.union([z.object({
                type: z.literal('ExtraTime'),
            }), z.object({
                type: z.literal('FirstHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('FirstInnings'),
            }), z.object({
                type: z.literal('FullTime'),
            }), z.object({
                type: z.literal('SecondHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('SetTR'),
            })]),
            type: z.literal('TwoWayKeyWithLine'),
        }), z.object({
            typeId: z.string(),
            bettable: TradingBettableZod,
            timePeriod: z.union([z.object({
                type: z.literal('ExtraTime'),
            }), z.object({
                type: z.literal('FirstHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('FirstInnings'),
            }), z.object({
                type: z.literal('FullTime'),
            }), z.object({
                type: z.literal('SecondHalf'),
            }), z.object({
                no: z.number(),
                type: z.literal('SetTR'),
            })]),
            team: z.string(),
            type: z.literal('TwoWayKeyWithLineAndTeam'),
        })]),
        type: z.literal('Multiple'),
    }), z.object({
        marketType: z.union([z.object({
            first: TradingStandardZod,
            second: TradingStandardZod,
            join: z.string(),
            no: z.number().optional().nullable(),
            type: z.literal('Double'),
        }), z.object({
            name: z.string(),
            type: z.literal('Manual'),
        }), z.object({
            name: z.string(),
            type: z.literal('RaceWinner'),
        }), z.object({
            source: z.union([z.object({
                type: z.literal('MarketKeyFightEnd'),
            }), z.object({
                type: z.literal('MarketKeyFightWinner'),
            }), z.object({
                name: z.string().optional().nullable(),
                type: z.literal('MarketKeyFlavorless'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                type: z.literal('MarketKeyInTimePeriod'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                type: z.literal('MarketKeyRaceTo'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                pointNumber: z.number(),
                type: z.literal('MarketKeyScorer'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                no: z.number(),
                type: z.literal('MarketKeyTimeOf'),
            }), z.object({
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                team: z.string(),
                type: z.literal('MarketKeyToKeepACleanSheet'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                type: z.literal('MarketThreeWayKey'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                type: z.literal('MarketThreeWayKeyWithLine'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                type: z.literal('MarketTwoWayKey'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                type: z.literal('MarketTwoWayKeyWithLine'),
            }), z.object({
                typeId: z.string(),
                bettable: TradingBettableZod,
                timePeriod: z.union([z.object({
                    type: z.literal('ExtraTime'),
                }), z.object({
                    type: z.literal('FirstHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('FirstInnings'),
                }), z.object({
                    type: z.literal('FullTime'),
                }), z.object({
                    type: z.literal('SecondHalf'),
                }), z.object({
                    no: z.number(),
                    type: z.literal('SetTR'),
                })]),
                line: z.number(),
                team: z.string(),
                type: z.literal('MarketTwoWayKeyWithLineAndTeam'),
            })]),
            type: z.literal('Standard'),
        })]),
        type: z.literal('Single'),
    })]),
    internalId: z.string(),
    betLimits: TradingBetLimitsZod,
});
export type TradingMarketBetLimitsLegacyViewType = z.TypeOf<typeof TradingMarketBetLimitsLegacyViewZod>;


// #/components/schemas/tradingBetLimitsGroupLegacyView
export const TradingBetLimitsGroupLegacyViewZod = z.object({
    name: z.string(),
    displayName: z.string(),
    marketBetLimits: z.array(TradingMarketBetLimitsLegacyViewZod).optional(),
    default: TradingBetLimitsZod,
});
export type TradingBetLimitsGroupLegacyViewType = z.TypeOf<typeof TradingBetLimitsGroupLegacyViewZod>;


// #/components/schemas/tradingBetLimitsGroupReplaceView
export const TradingBetLimitsGroupReplaceViewZod = z.object({
    name: z.string(),
    displayName: z.string(),
    marketBetLimits: z.array(TradingMarketBetLimitsViewZod).optional().nullable(),
    default: TradingBetLimitsZod.optional(),
});
export type TradingBetLimitsGroupReplaceViewType = z.TypeOf<typeof TradingBetLimitsGroupReplaceViewZod>;


// #/components/schemas/tradingPrice
export const TradingPriceZod = z.object({
    decimal: z.number(),
    fractional: z.string(),
});
export type TradingPriceType = z.TypeOf<typeof TradingPriceZod>;


// #/components/schemas/tradingPriceLadderStepView
export const TradingPriceLadderStepViewZod = z.object({
    price: TradingPriceZod,
    enabled: z.boolean(),
});
export type TradingPriceLadderStepViewType = z.TypeOf<typeof TradingPriceLadderStepViewZod>;


// #/components/schemas/tradingPriceLadderView
export const TradingPriceLadderViewZod = z.object({
    key: z.string(),
    steps: z.array(TradingPriceLadderStepViewZod).optional(),
    matchStrategy: z.string(),
});
export type TradingPriceLadderViewType = z.TypeOf<typeof TradingPriceLadderViewZod>;


// #/components/schemas/tradingPatchPriceLadderView
export const TradingPatchPriceLadderViewZod = z.object({
    steps: z.array(TradingPriceLadderStepViewZod).optional(),
});
export type TradingPatchPriceLadderViewType = z.TypeOf<typeof TradingPatchPriceLadderViewZod>;

